import React, { useContext, useState } from "react";

import DownloadIcon from '@mui/icons-material/GetApp';
import CloseIcon from "@mui/icons-material/CloseOutlined"
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import {Stack, Button, Box, Skeleton, Container, Modal, IconButton } from "@mui/material";

import { urlCheck } from "../../../utility/url-check";
import {getFormatedDate, getDateOnly } from "../../../utility/get-formated-date";
import { GenerateNewDocumentUrl } from "../../../utility/generate-new-document-url";
import config from "../../../hoa-config";
import datastore from "../../../store/hoa-datastore";
import { GlobalContext } from '../../../context/hoa-global-context';

const PropertyOverView = ({ hoa, overviewDetails, isHoaFetched }: any) => {

    const onFileDOwnloadClick = async(url :string) => {
        const newUrl = await GenerateNewDocumentUrl.getNewUrl(url, 'property', 'propertyNoticeFiles');
        window.open(urlCheck(newUrl), '_blank');
    }

    const details:any = {
        "ID": overviewDetails.objectId,
        "External ID":overviewDetails.hoaPropertyDetails['externalId'],
        "Property Address":overviewDetails['fullAddress'],
        "Organization":overviewDetails['organizationName'],
        "Date Bought by Owner":getFormatedDate(overviewDetails.hoaPropertyDetails['dateBoughtByOwner']),
        "Onboarding Date":getFormatedDate(overviewDetails.hoaPropertyDetails['onboardingDate']),
        "Current Owner":overviewDetails.hoaPropertyDetails['currentOwner'] || 'N/A',
        // "Current Resident":overviewDetails.hoaPropertyDetails['currentResident'],
        "Suggested HOA Name": overviewDetails.suggestedHoaName || 'N/A',
        "Securitized By":overviewDetails.hoaPropertyDetails['securitized'] || 'N/A',
        "Property Appraisal Value": overviewDetails.hoaPropertyDetails['propertyAppraisalValue'] || 'N/A',
        "Additional Information": overviewDetails.hoaPropertyDetails['propertyAppraisalAdditionalInfo'] || 'N/A',
        "Under Management": overviewDetails.hoaPropertyDetails['underManagement'] || 'N/A',
        "Additional Information ": overviewDetails.hoaPropertyDetails['underManagementAdditionalInfo'] ? overviewDetails.hoaPropertyDetails['underManagementAdditionalInfo'] : overviewDetails.hoaPropertyDetails['underManagementEffectiveSoldDateAdditionalInfo'] || 'N/A',
        "Effective Sold Date": getFormatedDate(overviewDetails.hoaPropertyDetails['effectiveSoldDate']) || 'N/A',
        "Acquisition Date": getFormatedDate(overviewDetails.hoaPropertyDetails['acquisitionDate']) || 'N/A',
        "Amount": overviewDetails.hoaPropertyDetails['amount'] || 'N/A',
        "Response Deadline": getDateOnly(overviewDetails.hoaPropertyDetails['responseDeadline']) || 'N/A',
        "Response Method": overviewDetails.hoaPropertyDetails['responseMethod'] || 'N/A',
        Notice: overviewDetails.propertyNoticeFiles || [],
    }

    return (
        <>
            <Stack borderBottom={"1px solid #E8E8E8"}>
                <Stack padding={'40px 24px 0px 24px'}>
                    <span className="text-3E3E3E-18px">Basic Information</span>
                    <Stack
                        style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["ID", "External ID", "Property Address", "Organization", "Date Bought by Owner", "Onboarding Date"].map(
                            (title: string, index: number) => {
                                if(datastore.userRole === config.userRoles.OrganizationUser && title === 'Date Bought by Owner') return null;
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginRight: "64px", marginTop: "24px" }}
                                        direction="column"
                                    >
                                        <span className="text-787878-14px bold">{title}</span>
                                        <span
                                            style={{ marginTop: "10px" }}
                                            className="text-303030-16px normal"
                                        >
                                            {details[title]}
                                        </span>
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>

                    <Stack
                        style={{borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"column"}
                        flexWrap={"wrap"}
                    >
                        {["Current Owner", "Securitized By", "Property Appraisal Value", "Additional Information", "Suggested HOA Name"].map(
                            (title: string, index: number) => {
                                if(datastore.userRole === config.userRoles.OrganizationUser && (title === 'Current Owner' || title === 'Securitized By')) return null;
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginRight: "64px", marginTop: "24px" }}
                                        direction="row"
                                        alignItems="center"
                                    >
                                        <span className="text-787878-14px bold" style={{minWidth: "208px"}}>{title}</span>
                                        <span
                                            style={{whiteSpace: 'pre-line'}} 
                                            className="text-303030-16px normal"
                                        >
                                             {details[title]}
                                        </span>
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>
                    <Stack
                        style={{borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                        direction={"row"}
                        flexWrap={"wrap"}
                    >
                        {["Under Management", "Additional Information ", "Effective Sold Date", "Acquisition Date"].map(
                            (title: string, index: number) => {
                                return (
                                    <Stack
                                        key={index}
                                        style={{ marginRight: "64px", marginTop: "24px" }}
                                        direction="column"
                                    >
                                        <span className="text-787878-14px bold">{title}</span>
                                        <span
                                            style={{ marginTop: "10px", whiteSpace: 'pre-line'}} 
                                            className="text-303030-16px normal"
                                        >
                                             {details[title]}
                                        </span>
                                    </Stack>
                                );
                            }
                        )}
                    </Stack>
                </Stack>
            </Stack>
            <Stack borderBottom={Object.keys(hoa).length > 0 ? "1px solid #E8E8E8" : ""}>
                {
                    Object.keys(hoa).length === 0 ? <LoadingItem isHoaFetched={isHoaFetched} /> : <MunicipalityInformation municipality={hoa.municipality} />
                }
            </Stack>
            <Stack borderBottom={Object.keys(hoa).length > 0 ? "1px solid #E8E8E8" : ""}>
                {
                    Object.keys(hoa).length === 0 ? <LoadingItem isHoaFetched={isHoaFetched} /> : <HoaInformation hoa={hoa} />
                }
            </Stack>
            <Stack borderBottom={hoa.masterHoaId ? "1px solid #E8E8E8" : ""}>
                {
                    !hoa.masterHoaId ? <LoadingItem isHoaFetched={isHoaFetched} /> : <HoaInformation hoa={hoa.masterHoa} />
                }
            </Stack>
        </>
    )
}

export const MunicipalityInformation = ({municipality}:any) => {

    const { setViewMoreDetails, changeActiveMenu, updateSelectedValues, selectedValues, property } = useContext<any>(GlobalContext)

    const [open, setOpen] = useState(false);
    const [zips, setZips] = useState([]);
    const [name, setName] = useState('');

    const onViewMunicipalityDetailsClick = () => {
        const index = property.data.findIndex((value:any)=> value.objectId === selectedValues.objectId);
		changeActiveMenu('Municipalities',true)
		updateSelectedValues(municipality)
		setViewMoreDetails({
			prevTagType:'Properties',
			prevValues: selectedValues,
            prevIndex:index,
		})
	}

    const onClose = () => {
        setOpen(!open);
    }

    const handleZipModal = (name: string, zips: any) => {
        setOpen(!open);
        setName(name);
        setZips(zips);
    }

    const municipalityInformation: any = {
        'Name': municipality.name|| "N/A",
        'Market': municipality.market || "N/A",
        'City': municipality.city || "N/A",
        'State': municipality.state || "N/A",
        'Zip': municipality?.zip?.split(',') || "N/A",
    }

    return (
        <Stack margin={'24px'} marginBottom={'0px'} >
            <Stack direction={"row"} justifyContent={"space-between"}>
                <span className="overview-title-text">Municipality Information</span>
                <Button
                    onClick={() => onViewMunicipalityDetailsClick()}
                    style={{
                        textTransform: "capitalize",
                        width: "176px",
                        height: "40px",
                    }}
                    variant="outlined"
                    startIcon={<OpenInNewIcon />}
                >
                    <span className="text-3E3E3E-14px bold">View More Details</span>
                </Button>
            </Stack>
            <Stack
                style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                direction={"row"}
                flexWrap={"wrap"}
            >
                {Object.keys(municipalityInformation).map(
                    (title: string, index: number) => {
                        return (
                            <Stack
                                key={index}
                                style={{ marginRight: "64px", marginTop: "24px" }}
                                direction="column"
                            >
                                <span className="text-787878-14px bold">{title}</span>
                                <span className="ov-sub-title" style={{cursor: title === 'Zip' ? 'pointer' : ''}} onClick={title==="Zip" && municipalityInformation[title].length>5 ? ()=>handleZipModal(municipalityInformation['Name'], municipalityInformation[title]) : undefined}>
                                    {title == 'Zip' ? 
                                    `${municipalityInformation[title].length>5 ? 
                                    `${municipalityInformation[title].slice(0,5)}  +${municipalityInformation[title].length-5} More` : municipalityInformation[title]}` : 
                                    municipalityInformation[title]}</span>
                            </Stack>
                        );
                    }
                )}
                <ZipModal
                    open={open}
                    onClose={onClose}
                    name={name}
                    zips={zips}
                />
            </Stack>
        </Stack>
    )
}

export const HoaInformation = ({hoa}:any) => {

    const details:any = {
        'HOA Name':hoa['name'],
        'HOA Address':hoa['address'],
        'ID':hoa['objectId'],
        'Market':hoa.municipality['market'],
        'City':hoa.municipality['city'],
        'Zip' : hoa['zip'],
        'State':hoa.municipality['state'],
        'Phone number':hoa.phone,
        'Email':hoa.email,
    }

    const { setViewMoreDetails, changeActiveMenu, updateSelectedValues, selectedValues, property } = useContext<any>(GlobalContext)

    const onVieHoaDetailsClick = () => {
        const index = property.data.findIndex((value:any)=> value.objectId === selectedValues.objectId);
		changeActiveMenu('HOAs',true)
		updateSelectedValues(hoa)
		setViewMoreDetails({
			prevTagType:'Properties',
			prevValues: selectedValues,
            prevIndex:index,
		})
	}

    const renderHoaType = (hoa:any) => {
		if(hoa && hoa.name) {
			const {
				masterHoa
			} = hoa;
	
			let backgroundColor = '';
			let type = '';
	
			if (masterHoa) {
				backgroundColor = "#EDE7F6";
				type = 'Sub-HOA';
			}
			else {
				backgroundColor = '#FFECB3';
				type = 'Master HOA'
			}
	
			
			return (
				<div className="text-787878-14px bold" style={{ background: backgroundColor, padding: "5px 15px 5px 15px", textAlign: "center", borderRadius: 4, fontWeight: 500, minWidth: 60, width: 80 }}>
					{type}
				</div>
			);	
		}
		else {
			return <></>;
		}
    }

    return (
        <Stack margin={'24px'} marginBottom={'0px'} >
            <Stack direction={"row"} justifyContent={"space-between"}>
                <span className="overview-title-text">HOA Information</span>
                <Button
                    onClick={() => onVieHoaDetailsClick()}
                    style={{
                        textTransform: "capitalize",
                        width: "176px",
                        height: "40px",
                    }}
                    variant="outlined"
                    startIcon={<OpenInNewIcon />}
                >
                    <span className="text-3E3E3E-14px bold">View More Details</span>
                </Button>
            </Stack>
            <Stack
                style={{ borderBottom: "1px solid #E8E8E8", paddingBottom: "24px" }}
                direction={"row"}
                flexWrap={"wrap"}
            >
                {["HOA Name", "HOA Address", "Type"].map(
                    (title: string, index: number) => {
                        return (
                            <Stack
                                key={index}
                                style={{ marginRight: "64px", marginTop: "24px" }}
                                direction="column"
                            >
                                <span className="text-787878-14px bold">{title}</span>
                                <span
                                    style={{ marginTop: "10px" }}
                                    className="text-303030-16px normal"
                                >
                                        {title === "Type" ?
                                            renderHoaType(hoa)
                                            :
                                            details[title]
                                        }
                                </span>
                            </Stack>
                        );
                    }
                )}
            </Stack>
            <Stack
                style={{ paddingBottom: "24px" }}
                direction={"row"}
                flexWrap={"wrap"}
            >
                {["ID", "Market", "City", "Zip", "State", "Phone number", "Email"].map(
                    (title: string, index: number) => {
                        return (
                            <Stack
                                key={index}
                                style={{ marginRight: "64px", marginTop: "24px" }}
                                direction="column"
                            >
                                <span className="text-787878-14px bold">{title}</span>
                                <span
                                    style={{ marginTop: "10px" }}
                                    className="text-303030-16px normal"
                                >
                                    {details[title]}
                                </span>
                            </Stack>
                        );
                    }
                )}
            </Stack>
        </Stack>
    )
}

export const LoadingItem = ({isHoaFetched}:any) => {

    return isHoaFetched && (
        <>
            <Stack
                style={{ borderBottom: "1px solid #E8E8E8", padding: "0px 24px 24px 24px" }}
                direction={"row"}
                flexWrap={"wrap"}
            >
                {["Name", "Market", "City", "State", "Zip"].map(
                    (title: string, index: number) => {
                        return (
                            <Stack
                                key={index}
                                style={{ marginRight: "64px", marginTop: "24px" }}
                                direction="column"
                            >
                                <Box sx={{ width: 100 }}>
                                    <Skeleton animation="wave" />
                                    <Skeleton animation="wave" />
                                </Box>
                            </Stack>
                        );
                    }
                )}
            </Stack>
        </>
    )
}

const ZipModal = ({zips, open, onClose, name}: any) => {
    return(
        <Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "450px",
					maxHeight: "645px",
					overflow: "auto",
					padding: "0px",
				}}
			>
				<div>
					<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', backgroundColor: '#EFF4FC', padding: '24px'}}>
                        <div>
                            <h3 style={{color: '#3E3E3E'}}>View Zip</h3>
                            <p>Showing all zip code for municipality-{name}</p>
                        </div>
						<IconButton
							onClick={() => onClose()}>
							<CloseIcon
								style={{cursor: "pointer"}}
							/>
						</IconButton>
					</div>
                    <div style={{padding: '24px'}}>
                        <span>Total Zip: {zips.length}</span>
                        <hr/>
                        {zips && zips.map((zip: any, index: number) => <span key={index}>{zip},</span>)}
                    </div>
				</div>
			</Container>
		</Modal>
    )
}

export default PropertyOverView;